module.exports = __webpack_public_path__ + "593a3d53/img/settings-icon.121d9519.svg";